import { config } from 'client/hooks/config';
import { Api } from 'common/utils/api';
import { useMutation, useQueryClient } from 'react-query';

type useUpdatePublicProps = {
    isPublic: boolean;
    jobId: string;
};

type Response = any;

export const useUpdatePublic = () => {
    const queryClient = useQueryClient();
    const { key, path } = config.videoexport.updatePublic();
    const { mutateAsync, isLoading } = useMutation(
        key,
        async ({ isPublic, jobId }: useUpdatePublicProps) => {
            const results = Api.put<Response>({ path, body: { isPublic, jobId } });
            return results;
        },
        {
            onSuccess: () => {
                queryClient.invalidateQueries(key);
                queryClient.invalidateQueries(config.videoexport.jobList().key);
            },
            onError: () => {
                queryClient.invalidateQueries(key);
            },
        }
    );
    return { updatePublic: mutateAsync, isLoading };
};
